/** Human-readable label for last warehouse audit (par/reject save at hub storage site). */
export function formatTomVendingLastAudit(
  iso: string | null | undefined,
  byDisplayName?: string | null,
): string {
  const trimmed = (iso ?? '').trim();
  if (!trimmed) {
    return 'Never audited';
  }
  const date = new Date(trimmed);
  if (Number.isNaN(date.getTime())) {
    return trimmed;
  }
  const when = date.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
  const who = (byDisplayName ?? '').trim();
  return who ? `${when} (${who})` : when;
}
